import { Injectable } from '@angular/core';

import { Config } from '@core/config/config';

import { lastValueFrom } from 'rxjs';

import { TranslateService } from '@ngx-translate/core';

import { SentenceCasePipe } from '@shared/pipes/sentence-case/sentence-case.pipe';

@Injectable({
  providedIn: 'root',
})
export class TextTranslateService {
  public COMMON = {
    TITLE_SELECT_LANGUAGE: '',
    MESSAGE_SELECT_LANGUAGE: '',
    ACTION_SELECT_LANGUAGE: '',
    TEMPLATE_GENERATED: '',
    REPORT_GENERATED: '',
    CONFIRM_REQUIRED: '',
    FILES_UPLOADED: '',
  };

  constructor(private translate_service: TranslateService) {
    this.initializeCommonText().then();
  }

  async generateTextTransform(
    value: string,
    sentenceCasePipe?: SentenceCasePipe
  ): Promise<string> {
    const text = await lastValueFrom(this.translate_service.get(value));
    if (sentenceCasePipe) {
      return sentenceCasePipe.transform(text);
    } else {
      return text;
    }
  }

  async initializeCommonText() {
    this.COMMON.TITLE_SELECT_LANGUAGE = await this.getCommon(
      'general.languageSelection'
    );
    this.COMMON.MESSAGE_SELECT_LANGUAGE = await this.getCommon(
      `${Config.WARNING_MESSAGES_PREFIX}.selectLanguageWhichGenerateDocumentToExport`
    );
    this.COMMON.ACTION_SELECT_LANGUAGE = await this.getCommon('general.export');
    this.COMMON.TEMPLATE_GENERATED = await this.getCommon(
      `${Config.SUCCESS_MESSAGES_PREFIX}.templateGenerated`
    );
    this.COMMON.REPORT_GENERATED = await this.getCommon(
      `${Config.SUCCESS_MESSAGES_PREFIX}.reportGenerated`
    );
    this.COMMON.CONFIRM_REQUIRED = await this.getCommon(
      `${Config.WARNING_MESSAGES_PREFIX}.confirmationRequired`
    );
    this.COMMON.FILES_UPLOADED = await this.getCommon(
      `${Config.SUCCESS_MESSAGES_PREFIX}.filesUploaded`
    );
  }

  private async getCommon(value: string) {
    return await this.generateTextTransform(value);
  }
}
